import { apiClient } from './api'

export interface ProjectDecisionItem {
  id: number
  project_id: number
  title: string
  description: string | null
  category: string | null
  status: string | null
  priority: string | null
  requested_by: string | null
  decision_maker: string | null
  date_requested: string | null
  date_decided: string | null
  due_date: string | null
  impact: string | null
  rationale: string | null
  alternatives: string | null
  stakeholders: string[] | null
  position: number
  created_at: string | null
  updated_at: string | null
}

export interface ProjectDecisionCreate {
  title: string
  description?: string | null
  category?: string | null
  status?: string | null
  priority?: string | null
  requested_by?: string | null
  decision_maker?: string | null
  date_requested?: string | null
  date_decided?: string | null
  due_date?: string | null
  impact?: string | null
  rationale?: string | null
  alternatives?: string | null
  stakeholders?: string[] | null
  position?: number
}

export const projectDecisionsService = {
  list(projectId: number): Promise<ProjectDecisionItem[]> {
    return apiClient.get(`/api/v1/projects/${projectId}/decisions/`).then((r) => r.data)
  },
  create(projectId: number, body: ProjectDecisionCreate): Promise<ProjectDecisionItem> {
    return apiClient.post(`/api/v1/projects/${projectId}/decisions/`, body).then((r) => r.data)
  },
  get(projectId: number, itemId: number): Promise<ProjectDecisionItem> {
    return apiClient.get(`/api/v1/projects/${projectId}/decisions/${itemId}`).then((r) => r.data)
  },
  update(projectId: number, itemId: number, body: Partial<ProjectDecisionCreate>): Promise<ProjectDecisionItem> {
    return apiClient.patch(`/api/v1/projects/${projectId}/decisions/${itemId}`, body).then((r) => r.data)
  },
  delete(projectId: number, itemId: number): Promise<void> {
    return apiClient.delete(`/api/v1/projects/${projectId}/decisions/${itemId}`)
  },
}
